import { Edit, SimpleForm, ShowButton, useRedirect, useNotify, useRefresh } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";

import dataProvider from "server/dataProvider";
import { AdministrationServicePath, SPECIALITIES } from "utils/constants";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

const EditSpecialities = () => {
  const refresh = useRefresh();
  const redirect = useRedirect();
  const notify = useNotify();

  const specialitySave = async data => {
    const transformedData = {
      ...data,
      studyDurationDtos:
        data.studyDurationDtos?.map(sd => ({
          ...sd,
        })) ?? [],
    };

    try {
      await dataProvider.update(AdministrationServicePath + SPECIALITIES, {
        id: data.id,
        data: transformedData,
      });
      notify("Успешно редактиране", { type: "success" });
      redirect("list", AdministrationServicePath + SPECIALITIES);
      refresh();
    } catch (error) {
      notify(`Error: ${error.message || "Грешка при редактиране"}`, { type: "error" });
    }
  };

  return (
    <Edit
      title="Редакция на специалност"
      mutationMode="pessimistic"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canPreviewSpecialities}>
              <ShowButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleForm
        toolbar={<InactiveDeleteOptionEditToolbar />}
        onSubmit={specialitySave}
      >
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditSpecialities;
